const HeartIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    className={className}
  >
    <path
      d="M17.75 0.75267C15.246 0.75267 12.973 2.6294 12 5.16719C11.027 2.62838 8.754 0.75267 6.25 0.75267C2.804 0.75267 0 3.59564 0 7.08954C0 13.9435 9.754 21.3551 11.709 22.7705L12 22.9814L12.291 22.7705C14.247 21.3551 24 13.9425 24 7.08954C24 3.59564 21.196 0.75267 17.75 0.75267ZM12 21.7333C6.859 17.9464 1 11.9279 1 7.08954C1 4.1543 3.355 1.76657 6.25 1.76657C8.998 1.76657 11.5 4.66632 11.5 7.84997H12.5C12.5 4.66632 15.002 1.76657 17.75 1.76657C20.645 1.76657 23 4.1543 23 7.08954C23 11.9279 17.141 17.9464 12 21.7333Z"
      fill="currentColor"
    />
  </svg>
);

export default HeartIcon;
